import ReactGA from 'react-ga4'

import { store } from '@/store/store'
import { PriceMapType } from '@/types/card'

import { initialPriceSources } from '../initialState'

import { SET_USER_STATE } from './types'

const euCountries = [
  'AT',
  'BE',
  'BG',
  'CH',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GB',
  'GR',
  'HR',
  'HU',
  'IE',
  'IS',
  'IT',
  'JP',
  'LI',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
]

const prependPriceSource = (priceSource: string, priceSources: Array<keyof PriceMapType>) =>
  [priceSource, priceSources[0], priceSources[1]] as Array<keyof PriceMapType>

const setCountry = async (country: string) => {
  const dispatch = store.dispatch
  const state = store.getState()

  try {
    let priceSources = state.user.priceSources
    if (state.user.country !== country && state.user.priceSources[0] !== initialPriceSources[2]) {
      if (country == 'CA') {
        priceSources = prependPriceSource('face2face', state.user.priceSources)
      } else if (euCountries.includes(country)) {
        priceSources = prependPriceSource('cardtrader', state.user.priceSources)
        priceSources = prependPriceSource('cardmarket', state.user.priceSources)
      }
    }

    priceSources.map((source) =>
      ReactGA.event({
        action: 'Init Price Source',
        category: 'Pricing',
        label: `country:${country}|source:${source}`,
        nonInteraction: true,
      }),
    )

    dispatch({
      payload: {
        country,
        priceSources,
      },
      type: SET_USER_STATE,
    })
  } catch (err) {
    console.error(err)
  }
}

export default setCountry
